/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_ITEMS_SUCCESS,
  LOAD_ITEMS_ERROR,
  LOAD_BRAND_LIST_SUCCESS,
  LOAD_BRAND_LIST_ERROR,
  CREATE_BRAND_LIST_SUCCESS,
  CREATE_BRAND_LIST_ERROR,
  LOAD_GRADE_LIST_SUCCESS,
  LOAD_GRADE_LIST_ERROR,
  CREATE_GRADE_LIST_SUCCESS,
  CREATE_GRADE_LIST_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_ITEMS_RECORDS_META_DATA_SUCCESS,
  LOAD_ITEMS_RECORDS_META_DATA_ERROR,
  CREATE_ITEMS_SUCCESS,
  UPDATE_ITEMS_SUCCESS,
  DELETE_ITEMS_SUCCESS,
  CREATE_ITEMS_ERROR,
  UPDATE_ITEMS_ERROR,
  DELETE_ITEMS_ERROR,
  LOAD_CATEGORY_SUCCESS,
  LOAD_CATEGORY_ERROR,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_ERROR,
  ADJUST_STOCK_SUCCESS,
  ADJUST_STOCK_ERROR,
  STOCK_DETAILS_SUCCESS,
  STOCK_DETAILS_ERROR,
  LOAD_STOCK_VALUE_SUCCESS,
  LOAD_STOCK_VALUE_ERROR,
  LOAD_PARTY_WISE_REPORT_SUCCESS,
  LOAD_PARTY_WISE_REPORT_ERROR,
} from "./constants";

const initialState = {
  items_list: [],
  brand_list: [],
  grade_list: [],
  category_list: [],
  stock_details: [],
  stock_value_list: {},
  party_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    items_list,
    brand_list,
    grade_list,
    category_list,
    stock_details,
    stock_value_list,
    party_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ITEMS_SUCCESS:
        draft.items_list = items_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_BRAND_LIST_SUCCESS:
        draft.brand_list = brand_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_GRADE_LIST_SUCCESS:
        draft.grade_list = grade_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CATEGORY_SUCCESS:
        draft.category_list = category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case STOCK_DETAILS_SUCCESS:
        draft.stock_details = stock_details;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTY_WISE_REPORT_SUCCESS:
        draft.party_list = party_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_STOCK_VALUE_SUCCESS:
        draft.stock_value_list = stock_value_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case CREATE_BRAND_LIST_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case CREATE_GRADE_LIST_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case CREATE_CATEGORY_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case ADJUST_STOCK_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case CREATE_ITEMS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_ITEMS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_ITEMS_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_ITEMS_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_ITEMS_ERROR:
      case LOAD_BRAND_LIST_ERROR:
      case CREATE_BRAND_LIST_ERROR:
      case LOAD_GRADE_LIST_ERROR:
      case CREATE_GRADE_LIST_ERROR:
      case LOAD_CATEGORY_ERROR:
      case STOCK_DETAILS_ERROR:
      case LOAD_STOCK_VALUE_ERROR:
      case LOAD_PARTY_WISE_REPORT_ERROR:
      case ADJUST_STOCK_ERROR:
      case CREATE_CATEGORY_ERROR:
      case CREATE_ITEMS_ERROR:
      case UPDATE_ITEMS_ERROR:
      case DELETE_ITEMS_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_ITEMS_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
